import { Dispatch } from 'redux';
import { RSAA } from 'redux-api-middleware';
import jwt from 'jsonwebtoken';

import { ClippingPlatformState } from 'store/clippingPlatformState';
import { createRefreshToken } from './api/auth.actions';
import { normalizeSession } from 'api/normalizers/sessionNormalizers';
import { InternalActionTypes } from 'constants/actionTypes';
import { createLogoutAction } from 'actions/logoutActions';
import { Token } from './auth.middleware.types';
import { isTokenExpired } from './auth.middleware.utils';

let refreshPromise: Promise<any> | null = null;

export const authMiddleware = (store: any) => {
  return (next: Dispatch<any>) => (action: any) => {
    const apiCall = action[RSAA];

    // eslint-disable-next-line no-shadow
    const nextAuth = (action: any) => {
      const {
        appStatus: {
          session: { sessionToken },
        },
      } = store.getState() as ClippingPlatformState;

      return next({
        [RSAA]: {
          ...action[RSAA],
          headers: {
            ...action[RSAA].headers,
            Authorization: `Bearer ${sessionToken}`,
          },
        },
      });
    };

    if (apiCall) {
      if (apiCall.isPublic) {
        delete apiCall.isPublic;

        return next(action);
      }

      const { sessionToken } = store.getState().appStatus.session;

      if (sessionToken) {
        const { exp, refreshToken, id } = jwt.decode(sessionToken) as Token;

        if (isTokenExpired(exp)) {
          if (!refreshPromise) {
            if (!refreshPromise) {
              // eslint-disable-next-line no-shadow
              refreshPromise = store.dispatch(createRefreshToken(refreshToken, id)).then((apiCall: any) => {
                refreshPromise = null;

                return apiCall;
              });
            }
          }

          if (refreshPromise) {
            // eslint-disable-next-line no-shadow
            return refreshPromise.then(apiCall => {
              if (apiCall.error) {
                return store.dispatch(createLogoutAction());
              }

              store.dispatch({ type: InternalActionTypes.LoginSuccessful, result: normalizeSession(apiCall.payload) });

              return nextAuth(action);
            });
          }
        }

        return nextAuth(action);
      }
    }

    return next(action);
  };
};
